import { useState, useCallback, useContext, useEffect } from 'react'
import { UNSAFE_NavigationContext } from 'react-router-dom'

/**
 * 더티 상태 관리 + 라우트/새로고침/뒤로가기 차단
 */
export default function useDirtyPrompt(message = "작성 중인 내용이 사라질 수 있습니다. 이동하시겠습니까?") {
  const [isDirty, setIsDirty] = useState(false)
  const { navigator } = useContext(UNSAFE_NavigationContext)

  // 여러 배열/값을 체크해서 dirty 상태 업데이트
  const updateIsDirty = useCallback((...lists) => {
    const hasValue = lists.some(list =>
      Array.isArray(list)
        ? list.some(v => (v ?? '').toString().trim() !== '')
        : (list ?? '').toString().trim() !== ''
    )
    setIsDirty(hasValue)
  }, [])

  // 라우트 이동 막기 (PUSH/REPLACE/POP)
  useEffect(() => {
    if (!isDirty) return
    if (!navigator.block) return

    // block 등록
    const unblock = navigator.block((tx) => {
      if (window.confirm(message)) {
        // 확인 시 블록 해제 후 이동
        unblock()
        tx.retry()
      }
      // 취소 시 아무 동작도 하지 않음
    })

    return () => {
      unblock()
    }
  }, [isDirty, navigator, message])

  // 새로고침 / 브라우저 닫기 막기
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault()
        e.returnValue = '' // 크롬에서 필수
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [isDirty])

  return { isDirty, setIsDirty, updateIsDirty }
}
